import { useSuspenseQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Select } from "@/components/catalyst/Select";
import { orpc } from "@/orpc/client";
import { DeferClaimChart } from "./DeferClaimChart";

const TIME_RANGE_OPTIONS = [
	{ value: 1, label: "Last 24 hours" },
	{ value: 7, label: "Last week" },
	{ value: 30, label: "Last month" },
	{ value: 365, label: "Last year" },
] as const;

interface ActivityChartSectionProps {
	linkId: string;
}

export function ActivityChartSection({ linkId }: ActivityChartSectionProps) {
	const [days, setDays] = useState<number>(30);

	// Fetch time series data for chart
	const { data: timeSeries } = useSuspenseQuery(
		orpc.referralLinks.timeSeries.queryOptions({
			input: { id: linkId, days },
		}),
	);

	return (
		<div className="mt-8">
			<div className="flex items-center justify-between">
				<div>
					<h3 className="text-lg font-semibold text-base-content">Activity</h3>
					<p className="mt-1 text-sm text-base-content/60">
						Defers and claims over time
					</p>
				</div>
				<Select
					value={days}
					onChange={(e) => setDays(Number(e.target.value))}
					className="w-64!"
				>
					{TIME_RANGE_OPTIONS.map((option) => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
					))}
				</Select>
			</div>
			<div className="mt-4">
				<DeferClaimChart data={timeSeries} />
			</div>
		</div>
	);
}
